import type { Whatsapp } from "@/interfaces/whatsapp";
import { httpClient } from "@/lib/api";

export interface CreateWhatsappDto {
  name: string;
};

export interface UpdateWhatsappDto extends CreateWhatsappDto {
  id: number;
};

type CreateWhatsappResponse = Whatsapp;

type ListWhatsappResponse = {
  whatsapps: Whatsapp[];
};

export class WhatsappService {

  public static async create(payload: CreateWhatsappDto) {
    const { data } = await httpClient().post<CreateWhatsappResponse>(`/whatsapp`, payload);
    return data;
  };

  public static async update(payload: UpdateWhatsappDto) {
    const { data } = await httpClient().patch<CreateWhatsappResponse>(`/whatsapp/${payload.id}`, payload);
    return data;
  };

  public static async list() {
    const { data } = await httpClient().get<ListWhatsappResponse>(`/whatsapp`);
    return data.whatsapps;
  };

  public static async syncContacts() {
    const { data } = await httpClient().get<ListWhatsappResponse>(
      "/whatsapp/sync-contacts",
    );
    return data;
  };

  public static async restartConnection(id: string) {
    const { data } = await httpClient().get<number>(`/whatsapp/${id}/restart`);
    return data;
  };

  public static async removeConnection(id: string) {
    const { data } = await httpClient().delete(`/whatsapp/${id}`);
    return data;
  }
}
